import { create } from 'zustand';

interface DocumentVirusStore {
  documentIds: string[];
  addDocumentId: (documentId: string) => void;
  removeDocumentIds: (documentIds: string[]) => void;
}

const useDocumentVirusScanStore = create<DocumentVirusStore>()((set) => ({
  documentIds: [],
  addDocumentId: (id) => set((state) => ({ documentIds: [...state.documentIds, id] })),
  removeDocumentIds: (ids) =>
    set((state) => ({
      documentIds: state.documentIds.filter((i) => !ids.includes(i)),
    })),
}));

export default useDocumentVirusScanStore;
